module.exports = __webpack_public_path__ + "img/三星特级大师@2x.9004e05e.png";